// ** React Imports
import { Suspense, lazy } from "react"
import ReactDOM from "react-dom"

// ** Redux Imports
import { Provider } from "react-redux"
import { store } from "./redux/storeConfig/store"

// ** Intl, CASL & ThemeColors Context
import ability from "./configs/acl/ability"
import { ToastContainer } from "react-toastify"
import { AbilityContext } from "./utility/context/Can"
import { ThemeContext } from "./utility/context/ThemeColors"
import { IntlProviderWrapper } from "./utility/context/Internationalization"

// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner"

// ** Ripple Button
import "./@core/components/ripple-button"

// ** PrismJS
import "prismjs"
import "prismjs/themes/prism-tomorrow.css"
import "prismjs/components/prism-jsx.min"

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css"

// ** React Toastify
import "@styles/react/libs/toastify/toastify.scss"

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css"
import "./@core/scss/core.scss"
import "./assets/scss/style.scss"

// ** Service Worker
import * as serviceWorker from "./serviceWorker"
import oidcConfig from "./configs/oidcConfig"
import { AuthenticationProvider, oidcLog } from "@axa-fr/react-oidc-context"
import BlankLayout from "./@core/layouts/BlankLayout"
import LostSession from "./views/other/LostSession"
import NotAuthenticated from "./views/other/NotAuthenticated"
import Authenticating from "./views/other/Authenticating"
import UserConnected from "./views/other/UserConnected"

// ** Lazy load app
const LazyApp = lazy(() => import("./App"))

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <AbilityContext.Provider value={ability}>
        <AuthenticationProvider
          notAuthenticated={() => {
            return (
              <BlankLayout>
                <NotAuthenticated />
              </BlankLayout>
            )
          }}
          notAuthorized={() => {
            return <h1>You are not authorized!</h1>
          }}
          authenticating={() => {
            return (
              <BlankLayout>
                <Authenticating />
              </BlankLayout>
            )
          }}
          callbackComponentOverride={() => {
            return (
              <BlankLayout>
                <UserConnected />
              </BlankLayout>
            )
          }}
          sessionLostComponent={() => {
            return (
              <BlankLayout>
                <LostSession />
              </BlankLayout>
            )
          }}
          configuration={oidcConfig}
          loggerLevel={oidcLog.DEBUG}
          isEnabled={true}
        >
          <ThemeContext>
            <IntlProviderWrapper>
              <LazyApp />
              <ToastContainer newestOnTop />
            </IntlProviderWrapper>
          </ThemeContext>
        </AuthenticationProvider>
      </AbilityContext.Provider>
    </Suspense>
  </Provider>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
